export const getStoplist = store => store.stoplist

export const getStoppedDish = store => dishId => {
  return store.stoplist.dishes.find(x => parseInt(x.dishId) === parseInt(dishId))
}

export const verifyModifierInStoplist = store => modifierId => {
  return store.stoplist.options.includes(modifierId)
}
